import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgxTippyModule } from 'ngx-tippy-wrapper';

import { CustomFieldsModule } from 'src/app/components/custom-fields/custom-fields.module';
import { SharedDirectivesModule } from 'src/directives/shared-directives.module';

import { AvatarModule } from '../components/avatar/avatar.module';

import { DisplayInboundAppChatRoutingModule } from './display-inbound-app-chat-routing.module';
import { DisplayInboundAppChatComponent } from './display-inbound-app-chat.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DisplayInboundAppChatRoutingModule,
    CustomFieldsModule,
    AvatarModule,
    NgxTippyModule,
    SharedDirectivesModule,
  ],
  declarations: [DisplayInboundAppChatComponent],
})
export class DisplayInboundAppChatModule {}
